import React from 'react';
import { Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import StepSublistEditor from '../components/StepSublistEditor';
import { StepSection } from '../v2/constants';
import { IChatTaskFeatureConfig } from '@scale/shared/types/config';

type PerTurnStepsProps = {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  chatTaskFeatureConfig?: IChatTaskFeatureConfig;
  displayMLQualitySettings?: boolean;
  setForHeader?: boolean;
  navProps?: {
    currentSection?: StepSection;
    currentFieldId?: string;
  };
  setNavProps?: React.Dispatch<
    React.SetStateAction<{
      currentSection?: StepSection;
      currentFieldId?: string;
    }>
  >;
};

const PerTurnSteps = ({
  value,
  onSubmit,
  displayMLQualitySettings,
  setForHeader,
  navProps,
  setNavProps,
  chatTaskFeatureConfig,
}: PerTurnStepsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Per-Turn Steps</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Steps in this section are repeated for each turn in a multiturn chat session. When all steps
        are completed, the tasker will be asked to either continue with a new prompt or end the
        current chat session. This action cannot be removed.
      </Typography.Paragraph2>
      <StepSublistEditor
        value={value}
        onSubmit={onSubmit}
        property="turn"
        displayMLQualitySettings={displayMLQualitySettings}
        setForHeader={setForHeader}
        navProps={navProps}
        setNavProps={setNavProps}
        chatTaskFeatureConfig={chatTaskFeatureConfig}
      />
    </div>
  );
};

export default PerTurnSteps;
